import React from 'react';
import FirewallStage from './FirewallStage';
import './ContinuousReview.css';

function ContinuousReview() {
  return (
    <section className="aqp-section aqp-cr" data-screen-label="Continuous review">
      <div className="aqp-cr__glow" />
      <div className="aqp-cr__inner">
        <div className="aqp-reveal aqp-cr__head">
          <span className="aqp-eyebrow">Reviewed as it comes in</span>
          <h2 className="aqp-cr__h2">Every submission reviewed against your specifications, continuously.</h2>
          <p className="aqp-cr__lede">
            The point is to prevent problems, not just find them. Work is checked as it comes in, and anything
            off goes back for correction before it turns into a real issue. It works on your side, keeping
            quality on track across the project.
          </p>
        </div>

        <div className="aqp-reveal aqp-fit aqp-cr__fit" data-fit="1200">
          <div className="aqp-fit__scale" data-fit-scale="" style={{ width: 1200 }}>
            <FirewallStage />
          </div>
        </div>

        <div className="aqp-fit__hint" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M8 7l-4 5 4 5M16 7l4 5-4 5M4 12h16" />
          </svg>
          Scroll to explore the full diagram
        </div>
      </div>
    </section>
  );
}

export default ContinuousReview;
